__turbopack_context__.v({
  "active": "Default-module__WoYufa__active",
  "arrow": "Default-module__WoYufa__arrow",
  "background": "Default-module__WoYufa__background",
  "completeScore": "Default-module__WoYufa__completeScore",
  "donut": "Default-module__WoYufa__donut",
  "emptyStar": "Default-module__WoYufa__emptyStar",
  "fullStar": "Default-module__WoYufa__fullStar",
  "l": "Default-module__WoYufa__l",
  "m": "Default-module__WoYufa__m",
  "max": "Default-module__WoYufa__max",
  "partialStar": "Default-module__WoYufa__partialStar",
  "plainCircle": "Default-module__WoYufa__plainCircle",
  "s": "Default-module__WoYufa__s",
  "score": "Default-module__WoYufa__score",
  "scoreCircle": "Default-module__WoYufa__scoreCircle",
  "scoreCircleTrack": "Default-module__WoYufa__scoreCircleTrack",
  "starRating": "Default-module__WoYufa__starRating",
  "wrapper": "Default-module__WoYufa__wrapper",
  "xs": "Default-module__WoYufa__xs",
});
